define('collections/calendar/session/exercise/weight/weeks',[
    'underscore',
    'backbone',
    'utils',
    // Pull in the Model module from above
    'models/calendar/session/exercise/weight/week'
], function(
    // libs
    _, Backbone, U,
    // model
    MWeightWeek
) {

    var CWeightWeeks = Backbone.Collection.extend({
        model: MWeightWeek,

        initialize: function(models, opt) {
            opt = opt || {};
            this.multiEnabled = _.isUndefined(opt.multiEnabled) ? false : opt.multiEnabled;

            this.listenTo(this, {
                "add": this.onAdd,
                "reset": this.onReset,
            });
        },


        toggleMultiReps: function(val, options) {
            this.multiEnabled = val;
            this.each(function(week) {
                week.toggleMultiReps(val, options);
            });
        },

        pushWeek: function(count, options) {
            var models = [];
            while (count-- > 0) { // while count down to zero
                models.push(new MWeightWeek());
            }
            return this.push(models, options);
        },

        popWeek: function(count, options) {
            var models = this.rest(this.length - count);
            return this.remove(models, options);
        },

        onNumWeekChange: function(model, value, options) {
            var changes = value - this.length;
            if (changes < 0) {
                this.popWeek(Math.abs(changes));
            } else if (changes > 0) {
                this.pushWeek(changes);
            }
        },

        applyWeek: function(week, skip) {
            if (_.isUndefined(skip)) skip = 0;

            var appliedWeek = week.toJSON();
            this.chain().rest(Number(skip)).each(function(model) {
                model.set(appliedWeek);
            });
        },

        ////////////
        // events //
        ////////////
        onAdd: function(model, collection, options) {
            model.toggleMultiReps(this.multiEnabled);
        },

        onReset: function(collection, options) {
            this.each(function(model) {
                this.onAdd(model, collection, options);
            }, this);
        },


    });

    return CWeightWeeks;
});

